module.exports = __webpack_public_path__ + "static/media/Screenshot_1.63cf6364.png";